function SvgColdDrinks(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 27" {...props}>
      <g>
        <path d="M13.7.9l-1.6 4H.9l1.6 20c.1.7.6 1.2 1.3 1.2h9.6c.7 0 1.3-.5 1.3-1.2L16.2 5v-.1h-3l1.2-3h2.9v-1h-3.6zm-6 15.7c.9.8 2.1 1.2 3.3 1.2.7 0 1.4-.2 2.1-.5l1.2-.6-.6 8c0 .1-.1.3-.3.3H3.7c-.1 0-.3-.1-.3-.3l-.7-8.6c1.6-.9 3.5-.7 5 .5zm4.9-.2c-1.4.6-3.1.4-4.3-.6-.9-.8-2.1-1.2-3.3-1.2-.8 0-1.6.2-2.3.6L2 6h13.1l-.8 9.6-1.7.8z" />
        <path d="M6.2 21.3c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7 0 .9.7 1.7 1.7 1.7zm-.7-1.8c0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7zm5 4.2c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7 0 .9.8 1.7 1.7 1.7zM9.8 22c0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.4-.7-.7zm4.7-15.3c-.1-.1-.2-.2-.4-.2h-1.2c-.3 0-.5.2-.5.5 0 .1 0 .3.1.4.1.1.2.2.4.2h.6l-.7 6.3c0 .3.2.6.5.6s.5-.2.5-.5l.8-6.9c0-.1 0-.3-.1-.4z" />
      </g>
    </svg>
  );
}

export default SvgColdDrinks;
